import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { debounceTime, distinctUntilChanged, fromEvent, tap } from 'rxjs';

@Component({
    selector: 'search-input',
    templateUrl: './search-input.component.html',
    styleUrls: ['./search-input.component.scss'],
    standalone: false
})
export class SearchInputComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('input') input: ElementRef;

  @Input() placeholder: string = 'Search';
  @Input() value: string = '';
  @Input() showClear: boolean = false;

  @Output() onSubmit: EventEmitter<string> = new EventEmitter();

  inputValue: string = '';

  ngOnInit() {
    this.inputValue = this.value;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.value) {
      this.inputValue = this.value;
    }
  }

  ngAfterViewInit() {
    fromEvent(this.input.nativeElement, 'keyup')
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        tap((event: KeyboardEvent) => {
          this.inputValue = this.input.nativeElement.value;
          this.submit();
        }),
      )
      .subscribe();
  }

  clearSearch(): void {
    this.inputValue = '';
    this.submit();

    if (this.input?.nativeElement) {
      this.input.nativeElement.focus();
    }
  }

  submit() {
    this.onSubmit.emit(this.inputValue);
  }
}
